if (!customElements.get('museo-carousel')) {
  customElements.define(
    'museo-carousel',
    class MuseoCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.museo-carousel__track');
        if (!this.track) return;

        this.dragState = null;
        this.DRAG_THRESHOLD = 4;

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);

        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('click', this.onClickCapture, true);
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('pointerdown', this.onPointerDown);
        this.track.removeEventListener('click', this.onClickCapture, true);
      }

      onPointerDown(e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        this.dragState = {
          startX: e.clientX,
          startScrollLeft: this.track.scrollLeft,
          moved: false,
          pointerId: e.pointerId,
        };
        this.track.setPointerCapture(e.pointerId);
        this.track.addEventListener('pointermove', this.onPointerMove);
        this.track.addEventListener('pointerup', this.onPointerUp);
        this.track.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(e) {
        if (!this.dragState || e.pointerId !== this.dragState.pointerId) return;
        const dx = e.clientX - this.dragState.startX;
        if (!this.dragState.moved && Math.abs(dx) > this.DRAG_THRESHOLD) {
          this.dragState.moved = true;
          this.track.classList.add('is-dragging');
        }
        if (this.dragState.moved) {
          this.track.scrollLeft = this.dragState.startScrollLeft - dx;
          e.preventDefault();
        }
      }

      onPointerUp(e) {
        if (!this.dragState || e.pointerId !== this.dragState.pointerId) return;
        const moved = this.dragState.moved;
        this.track.removeEventListener('pointermove', this.onPointerMove);
        this.track.removeEventListener('pointerup', this.onPointerUp);
        this.track.removeEventListener('pointercancel', this.onPointerUp);
        try { this.track.releasePointerCapture(e.pointerId); } catch (_) {}
        this.track.classList.remove('is-dragging');
        this.suppressClick = moved;
        this.dragState = null;
        if (moved) {
          setTimeout(() => { this.suppressClick = false; }, 0);
        }
      }

      onClickCapture(e) {
        if (this.suppressClick) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }
  );
}
